/* eslint-disable max-len */
import { Avatar, AvatarGroup, Box, Grid, Typography } from '@mui/material';
import React from 'react';
import EditableBox from './EditableBox';

const ImgTemplateContent = (props) =>
{
	const { downSM, requestT, viewData, textState, occasionData, handleAttendees, avatarList, handleChange, hasGifTemplate } = props;

	return (
		<>
			{/* Normal-Card */}
			<Grid container p={downSM ? 1 : 2} display={'flex'}>
				<Grid item xs={12} display={'flex'} alignItems={'start'}>
					{requestT === 'viewEvent' && Boolean(viewData?.occasion?.title)
						? <Typography color={'#fff'} fontSize={downSM ? 14 : 28} fontWeight={500}> {viewData?.occasion?.title}</Typography>
						: <EditableBox content={textState?.title || occasionData?.title} char={50} clr='white' txtAln='start' fontsize={'18px'} placeholder={`Celebrating ${occasionData?.type}`} updateText={(event) => { handleChange(event, 'title'); }} hasGifTemplate={hasGifTemplate} />
					}
				</Grid>
				<Grid item xs={12} display={'flex'} minHeight={0} alignItems={'end'} pb={(requestT === 'viewEvent') ? '20px' : 0}>
					<Box display='flex' flexDirection='row' alignItems='center' width={'100%'}>
						<AvatarGroup
							onClick={handleAttendees}
							max={3}
							sx={{
								mr                         : 2,
								flexDirection              : 'row-reverse',
								'& .MuiAvatarGroup-avatar' : { width: (requestT === 'viewEvent') ? '50px' : '36px', height: (requestT === 'viewEvent') ? '50px' : '36px', fontSize: '14px', border: '2px solid #fff !important', cursor: 'pointer' },
								'& .MuiAvatar-root'        : {	marginLeft: '-18px', 	...[ ...Array(3) ].reduce((acc, _, index) => ({ ...acc, [`&:nth-of-type(${index + 1})`]: { zIndex: 3 - index } }), {}), '&:first-of-type': { border: '1px solid #24A4C4', color: '#24A4C4', background: '#F1F2F7', cursor: 'ponter' } }
							}}
						>
							{avatarList?.map((avatarUrl:any) => (<Avatar key={avatarUrl?.key} src={avatarUrl?.src} />))}
						</AvatarGroup>
						{requestT === 'viewEvent' && Boolean(viewData?.occasion?.text)
							? <Typography color={'#fff'} fontSize={(requestT === 'viewEvent') ? 28 : 14} fontWeight={500}> {viewData?.occasion?.text}</Typography>
							: <EditableBox 	content={textState?.text !== '' ? textState?.text : occasionData?.text} char={80} clr='white' txtAln='start' fontsize={'14px'} 	placeholder='Enter your greeting message...' updateText={(event) => { handleChange(event, 'text'); }} hasGifTemplate={hasGifTemplate} />
						}
					</Box>
				</Grid>
			</Grid>
		</>

	);
};

export default ImgTemplateContent;